__webpack_require__.p = "/reports-dashboard-templates-rename-sidebar/referrals-hub/";